import './style.styl'

export default {
  preloadBackground: null,
  preloadQRCode: null,
  data() {
    return {
      wechatStaffInfo:false,
      visible: false
    }
  },
  created() {
    const activityId = this.$route.params.eventId

    const preloadBackground = document.createElement('link')
    const preloadQRCode = document.createElement('link')

    preloadBackground.rel = 'preload'
    preloadQRCode.rel = 'preload'

    preloadBackground.as = 'image'
    preloadQRCode.as = 'image'

    preloadBackground.href = 'https://image.wxopen.shenhudong.com/4.0/sub.png'
    preloadQRCode.href = 'https://hd2.shenhudong.com/public/php/get_wx_qrcode_4.php?shdid=' + activityId

    this.$options.preloadBackground = preloadBackground
    this.$options.preloadQRCode = preloadQRCode

    console.log(this.$storage.getItem('wechatStaffInfo'))
    this.wechatStaffInfo = (this.$storage.getItem('wechatStaffInfo') === null || this.$storage.getItem('wechatStaffInfo') === '') ? false : JSON.parse(this.$storage.getItem('wechatStaffInfo'))
    console.log(this.wechatStaffInfo)
    document.getElementsByTagName('head')[0].appendChild(preloadBackground)
    document.getElementsByTagName('head')[0].appendChild(preloadQRCode)
  },
  render() {
    const activityId = this.$route.params.eventId

    return (
      <div>
        {
          !this.wechatStaffInfo ? null : (
            <div onClick={this.goMangerPage}>
              <img className="admin_center" src="https://image.wxopen.shenhudong.com/admin_center_icon.png?x-oss-process=style/uploadimg" style="position: fixed; z-index: 10; right: 0rem; bottom: 8.4rem; width: 3.5rem;"/>
            </div>
          )
        }
        <transition name="zoom">
          {
            !this.visible ? null : (
              <div id="dialog-shd-public-account" onClick={this.handleClickHideDialog}>
                <div class="mask"></div>
                <div class="dialog">
                  {/*<img class="bg" src="https://image.wxopen.shenhudong.com/4.0/sub.png" width="100%"/>*/}
                  {/*<img class="qrcode" src={'https://hd2.shenhudong.com/public/php/get_wx_qrcode_4.php?shdid=' + activityId}/>*/}
                  <img class="qrcode" src={'https://image.wxopen.shenhudong.com/shd_4/contact_me_qr_box.png'}/>
                </div>
              </div>
            )
          }
        </transition>
      </div>
    )
  },
  beforeDestroy() {
    this.$options.preloadBackground && this.$options.preloadBackground.remove()
    this.$options.preloadQRCode && this.$options.preloadQRCode.remove()

    this.$options.preloadBackground = null
    this.$options.preloadQRCode = null
  },
  methods: {
    goMangerPage(){
      location.href="https://www.shenhudong.com/act-data/index.php?uid="+this.wechatStaffInfo.uid
    },
    handleClickHideDialog() {
      this.visible = false
    }
  }
}